module.exports = "/images/buslog_logo.svg?6d675779c5e4749207e38fbd34fe7822";